import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard  {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

        const user = this.authService.getUser();
        if (!user || !user.isAdmin) {
            return this.router.navigateByUrl('/');
        }
        return true;
    }
}